import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from '../components/Home'
import About from '../components/About'
import Contact from '../components/Contact'
import Privacy from '../components/Privacy'
import LogIn from '../components/auth/LogIn'
import LogOut from '../components/auth/LogOut'
import LinkedIn from '../components/auth/LinkedIn'
import User from '../components/User'
import Profile from '../components/Profile'
import ExpoHome from '../components/expo/ExpoHome'
import ExpoRoom from '../components/expo/room/ExpoRoom'
import NewExpo from '../components/expo/NewExpo'
import EditMap from '../components/expo/EditMap'
import NotFound from '../components/NotFound'
import { auth } from '../db'
import { store } from '../store/store'

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => {
        if (err.name == 'NavigationDuplicated')
            return
        else
            throw err
    })
};

Vue.use(VueRouter)

export const router = new VueRouter({
    mode: 'history',
    scrollBehavior: () => new Promise((resolve) => {
        const position = { x: 0, y: 0 }
        router.app.$root.$once('triggerScroll', () => {
            router.app.$nextTick(() => resolve(position))
        })
    }),
    routes: [
        {
            path: '/home',
            name: 'Home',
            component: Home
        },
        {
            path: '/',
            redirect: {
                name: 'Home'
            }
        },
        {
            path: '/about',
            name: 'About',
            component: About
        },
        {
            path: '/contact',
            name: 'Contact',
            component: Contact
        },
        {
            path: '/privacy',
            name: 'Privacy',
            component: Privacy
        },
        {
            path: '/login',
            name: 'Log In',
            component: LogIn,
            props: true,
        },
        {
            path: '/signup',
            name: 'Sign Up',
            component: LogIn,
            props: true,
        },
        {
            path: '/linkedin',
            name: 'LinkedIn',
            component: LinkedIn,
            props: true,
        },
        {
            path: '/logout',
            name: 'Log Out',
            component: LogOut
        },
        {
            path: '/user/:userId',
            name: 'User',
            component: User,
            props: true,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/profile',
            name: 'Edit Profile',
            component: Profile,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/expo',
            name: 'Expos',
            component: ExpoHome,
            meta: {
                //requiresAuth: true
            }
        },
        {
            path: '/expo/:expoId',
            component: ExpoRoom,
            props: true,
            meta: {
                //requiresAuth: true
            }
        },
        {
            path: '/expo/:expoId/map',
            redirect: '/expo/:expoId',
            props: true,
            meta: {
                //requiresAuth: true
            }
        },
        {
            path: '/expo/:expoId/:roomId1',
            component: ExpoRoom,
            props: true,
            meta: {
                //requiresAuth: true
            }
        },
        {
            path: '/expo/:expoId/:roomId1/:roomId2',
            component: ExpoRoom,
            props: true,
            meta: {
                //requiresAuth: true
            }
        },
        {
            path: '/expo/:expoId/:roomId1/:roomId2/:roomId3',
            component: ExpoRoom,
            props: true,
            meta: {
                //requiresAuth: true
            }
        },
        {
            path: '/editexpo/:expoId',
            name: 'Edit Expo',
            component: EditMap,
            props: true,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/newexpo',
            name: 'New Expo',
            component: NewExpo,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '*',
            name: 'Not Found',
            component: NotFound
        }
  ]
})

router.beforeEach(async (to, from, next) => {
    store.dispatch("fetchUser", auth.currentUser)
    const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
    if (requiresAuth && !auth.currentUser) {
        store.dispatch('updatePageName', [{
            name: 'Log In',
            to: '/login'
        }])
        next({ name: 'Log In', params: { routeAfter: to.path} })
    } else {
        store.dispatch('updatePageName', [{
            name: to.name,
            to: to.path
        }])
        next()
    }
})